import React from 'react';
import { STEP_TOKEN_CREATION, STEP_TYPE } from './config';
import { twMerge } from 'tailwind-merge';

const CreationStep = ({
  step,
  setStep,
}: {
  step: STEP_TYPE;
  setStep: (step: STEP_TYPE) => void;
}) => {
  return (
    <div className="w-full">
      <div className="text-[#E4775D] text-[12px] font-semibold">
        STEP {step.id}
      </div>
      <div className="mt-3 flex justify-between items-center">
        <span className="font-semibold text-[#FCFCFC] text-[16px] md:text-[24px]">
          {step.title}
        </span>

        {/* {step.id === 1 && (
          <div className="flex items-center justify-center cursor-pointer h-8 rounded px-2 md:px-3 py-2 border border-[#30344A] bg-[#1A1C28]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M5.30234 5.25008C5.43948 4.86022 5.71018 4.53148 6.06648 4.32208C6.42278 4.11267 6.84169 4.03613 7.24902 4.106C7.65635 4.17586 8.02581 4.38764 8.29197 4.70381C8.55812 5.01998 8.70379 5.42014 8.70317 5.83342C8.70317 7.00008 6.95317 7.58342 6.95317 7.58342M6.99984 9.91675H7.00567M12.8332 7.00008C12.8332 10.2217 10.2215 12.8334 6.99984 12.8334C3.77818 12.8334 1.1665 10.2217 1.1665 7.00008C1.1665 3.77842 3.77818 1.16675 6.99984 1.16675C10.2215 1.16675 12.8332 3.77842 12.8332 7.00008Z"
                stroke="#9192A0"
                strokeWidth="1.16667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="ml-[6px] text-[#E8e9ee] font-medium">
              How to launch?
            </span>
          </div>
        )} */}
      </div>
      <div className="mb-4 w-full flex gap-2 justify-center item-center">
        {STEP_TOKEN_CREATION.map((item, index) => (
          <div
            key={`item-${item.value}-${item.id}-${index}`}
            className="py-6 flex-1 cursor-pointer hover:rounded hover:scale-105 ease-in transition-all duration-150"
            // onClick={() => setStep(item)}
          >
            <div
              className={twMerge(
                'cursor-pointer bg-[#30344A] flex-1 h-1 rounded',
                item.id <= step.id && 'bg-[#FCFCFC]',
              )}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CreationStep;
